export class Promotion {
  cartID: string = '';
  promoCode: string = '';
}
